import { makeApiRequest } from "../../lib/http/makeApiRequest";
import { ProxyAddonSelection } from "../../types/pricing.types";

export const createPaymentSession = async ({
  period,
  plan,
  addons
}: {
  period: string;
  plan: string;
  addons?: ProxyAddonSelection[];
}) => {
  const session = await makeApiRequest(`/v1/payment/stripe/payment-session`, {
    method: 'POST',
    body: JSON.stringify({ 
      plan, 
      period, 
      addons: addons || []
    }),
  });

  if (session.url) {
    window.location.href = session.url;
  }
};